import { render, staticRenderFns } from "./PolizasRMSResponse.vue?vue&type=template&id=23c2dfaa&scoped=true&"
import script from "./PolizasRMSResponse.vue?vue&type=script&lang=js&"
export * from "./PolizasRMSResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c2dfaa",
  null
  
)

export default component.exports